import { Box, Button, Typography } from "@mui/material";
import { CheckCircle } from "@mui/icons-material";
import { Link as RouterLink } from "react-router-dom";
import { PageLayout } from "@gui/widgets/PageLayout";

/**
 * Confirmation shown after a registration is submitted.
 *
 * Deliberately **not** a live region. This is a routed page (`/registration-notice`), not
 * something that appears in place beside a form the user is still reading — arriving here is a
 * navigation, and the content is the whole page rather than an update to it. `role="status"`
 * here would announce the page a second time on some AT and imply a pending update that never
 * comes. What it actually needed was what any page needs: a real `<h1>`, so heading order starts
 * at one and the page announces its own name.
 */
export const RegistrationContactNotice = () => {
	return (
		<PageLayout width="form">
			<Box display="flex" flexDirection="column" alignItems="center" textAlign="center" gap={1} pt={{ xs: 3, md: 6 }}>
				<CheckCircle color="success" sx={{ fontSize: 48 }} />
				<Typography variant="h6" component="h1">
					Registration submitted
				</Typography>
				<Typography color="text.secondary">
					Our team will be in touch shortly to finish setting up your account. Thank you for your patience.
				</Typography>
				<Button component={RouterLink} to="/login" variant="outlined" sx={{ mt: 2 }}>
					Back to Sign In
				</Button>
			</Box>
		</PageLayout>
	);
};
